// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"BreadcrumbsContainer_breadcrumbs__c3jmn"};